import * as i0 from '@angular/core';
import { signal, Optional, SkipSelf, inject, Directive, Input } from '@angular/core';
import { tuiCreateToken, tuiProvide } from '@taiga-ui/cdk/utils/miscellaneous';
import { TUI_DEFAULT_IDENTITY_MATCHER, TUI_FALSE_HANDLER } from '@taiga-ui/cdk/constants';
const TUI_DEFAULT_ITEMS_HANDLERS = {
  stringify: signal(String),
  identityMatcher: signal(TUI_DEFAULT_IDENTITY_MATCHER),
  disabledItemHandler: signal(TUI_FALSE_HANDLER)
};
/**
 * Default items handlers for components
 */
const TUI_ITEMS_HANDLERS = tuiCreateToken(TUI_DEFAULT_ITEMS_HANDLERS);
function tuiItemsHandlersProvider(options) {
  return {
    provide: TUI_ITEMS_HANDLERS,
    deps: [[new Optional(), new SkipSelf(), TUI_ITEMS_HANDLERS]],
    useFactory: parent => ({
      stringify: signal(parent?.stringify() ?? TUI_DEFAULT_ITEMS_HANDLERS.stringify()),
      identityMatcher: signal(parent?.identityMatcher() ?? TUI_DEFAULT_ITEMS_HANDLERS.identityMatcher()),
      disabledItemHandler: signal(parent?.disabledItemHandler() ?? TUI_DEFAULT_ITEMS_HANDLERS.disabledItemHandler()),
      ...options
    })
  };
}
let TuiItemsHandlersDirective = /*#__PURE__*/(() => {
  class TuiItemsHandlersDirective {
    constructor() {
      this.defaultHandlers = inject(TUI_ITEMS_HANDLERS, {
        skipSelf: true
      });
      this.stringify = signal(this.defaultHandlers.stringify());
      this.identityMatcher = signal(this.defaultHandlers.identityMatcher());
      this.disabledItemHandler = signal(this.defaultHandlers.disabledItemHandler());
    }
    // TODO(v5): use signal inputs
    set stringifySetter(x) {
      this.stringify.set(x);
    }
    // TODO(v5): use signal inputs
    set identityMatcherSetter(x) {
      this.identityMatcher.set(x);
    }
    // TODO(v5): use signal inputs
    set disabledItemHandlerSetter(x) {
      this.disabledItemHandler.set(x);
    }
    static {
      this.ɵfac = function TuiItemsHandlersDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiItemsHandlersDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiItemsHandlersDirective,
        inputs: {
          stringifySetter: [0, "stringify", "stringifySetter"],
          identityMatcherSetter: [0, "identityMatcher", "identityMatcherSetter"],
          disabledItemHandlerSetter: [0, "disabledItemHandler", "disabledItemHandlerSetter"]
        },
        features: [i0.ɵɵProvidersFeature([tuiProvide(TUI_ITEMS_HANDLERS, TuiItemsHandlersDirective)])]
      });
    }
  }
  return TuiItemsHandlersDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiWithItemsHandlers = /*#__PURE__*/(() => {
  class TuiWithItemsHandlers {
    static {
      this.ɵfac = function TuiWithItemsHandlers_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiWithItemsHandlers)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiWithItemsHandlers,
        features: [i0.ɵɵHostDirectivesFeature([{
          directive: TuiItemsHandlersDirective,
          inputs: ["stringify", "stringify", "identityMatcher", "identityMatcher", "disabledItemHandler", "disabledItemHandler"]
        }])]
      });
    }
  }
  return TuiWithItemsHandlers;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_DEFAULT_ITEMS_HANDLERS, TUI_ITEMS_HANDLERS, TuiItemsHandlersDirective, TuiWithItemsHandlers, tuiItemsHandlersProvider };
